<template>
    <div id="expanded-filter">
        <div class="section">
            <div class="label">Archived Status</div>
            <div class="toggle-button-group">
                <button
                    :class="{active: filter.is_archived === true}"
                    @click="updateFilterProp({name: 'is_archived', value: true})"
                >Archived</button>
                <button
                    :class="{active: filter.is_archived === false}"
                    @click="updateFilterProp({name: 'is_archived', value: false})"
                >Unarchived</button>
                <button
                    :class="{active: filter.is_archived === ''}"
                    @click="updateFilterProp({name: 'is_archived', value: ''})"
                >Both</button>
            </div>
        </div>

        <div class="section">
            <div class="label">Read Status</div>
            <div class="toggle-button-group">
                <button
                    :class="{active: filter.is_read === true}"
                    @click="updateFilterProp({name: 'is_read', value: true})"
                >Read</button>
                <button
                    :class="{active: filter.is_read === false}"
                    @click="updateFilterProp({name: 'is_read', value: false})"
                >Unread</button>
                <button
                    :class="{active: filter.is_read === ''}"
                    @click="updateFilterProp({name: 'is_read', value: ''})"
                >Both</button>
            </div>
        </div>

        <div class="section">
            <div class="label">
                Created
                <span
                    class="clear"
                    v-if="!!Object.keys(activeFilter).find(k => k.includes('created_at'))"
                    @click.stop="e => {
                        updateFilterProp({name: 'date#created_at#from', value: ''})
                        updateFilterProp({name: 'date#created_at#to', value: ''})
                        updateFilterProp({name: 'date#created_at#on', value: ''})
                    }"
                >(Clear)</span>
            </div>
            <div class="date-group">
                <div class="toggle-button-group">
                    <button
                        :class="{active: !showRange.created_at}"
                        @click="showRange.created_at = false"
                    >On</button>
                    <button
                        :class="{active: showRange.created_at}"
                        @click="showRange.created_at = true"
                    >Between</button>
                </div>
                <div v-show="showRange.created_at" class="dates">
                    <input
                        type="text"
                        ref="createdAtFrom"
                        placeholder="Date"
                        :value="filter['date#created_at#from']"
                        @change="e => updateFilterProp({name: 'date#created_at#from', value: e.target.value})"
                    />
                    <span class="range-and">and</span>
                    <input
                        type="text"
                        ref="createdAtTo"
                        placeholder="Date"
                        :value="filter['date#created_at#to']"
                        @change="e => updateFilterProp({name: 'date#created_at#to', value: e.target.value})"
                    />
                </div>
                <div v-show="!showRange.created_at" class="dates">
                    <input
                        type="text"
                        ref="createdAtOn"
                        placeholder="Date"
                        :value="filter['date#created_at#on']"
                        @change="e => updateFilterProp({name: 'date#created_at#on', value: e.target.value})"
                    />
                </div>
            </div>
        </div>
        <div class="section">
            <div class="label">
                Last Updated
                <span
                    class="clear"
                    v-if="!!Object.keys(activeFilter).find(k => k.includes('updated_at'))"
                    @click.stop="e => {
                        updateFilterProp({name: 'date#updated_at#from', value: ''})
                        updateFilterProp({name: 'date#updated_at#to', value: ''})
                        updateFilterProp({name: 'date#updated_at#on', value: ''})
                    }"
                >(Clear)</span>
            </div>
            <div class="date-group">
                <div class="toggle-button-group">
                    <button
                        :class="{active: !showRange.updated_at}"
                        @click="showRange.updated_at = false"
                    >On</button>
                    <button
                        :class="{active: showRange.updated_at}"
                        @click="showRange.updated_at = true"
                    >Between</button>
                </div>
                <div v-show="showRange.updated_at" class="dates">
                    <input
                        type="text"
                        ref="updatedAtFrom"
                        placeholder="Date"
                        :value="filter['date#updated_at#from']"
                        @change="e => updateFilterProp({name: 'date#updated_at#from',value: e.target.value})"
                    />
                    <span class="range-and">and</span>
                    <input
                        type="text"
                        ref="updatedAtTo"
                        placeholder="Date"
                        :value="filter['date#updated_at#to']"
                        @change="e => updateFilterProp({name: 'date#updated_at#to',value: e.target.value})"
                    />
                </div>
                <div v-show="!showRange.updated_at" class="dates">
                    <input
                        type="text"
                        ref="updatedAtOn"
                        placeholder="Date"
                        :value="filter['date#updated_at#on']"
                        @change="e => updateFilterProp({name: 'date#updated_at#on',value: e.target.value})"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapMutations } from 'vuex';
    import { constants } from '../../utils';
    import flatpickr from 'flatpickr';

    export default {
        name: 'ExpandedFilter',
        data() {
            return {
                constants,
                pickers: [],
                showRange: {
                    updated_at: true,
                    created_at: true,
                },
            };
        },
        computed: {
            ...mapGetters({
                filter: 'boxes/filter',
                activeFilter: 'boxes/activeFilter',
            }),
        },
        methods: {
            ...mapMutations({
                updateFilterProp: 'boxes/updateFilterProp',
            }),
            initDatePicker() {
                [
                    'updatedAtFrom',
                    'updatedAtTo',
                    'updatedAtOn',
                    'createdAtFrom',
                    'createdAtTo',
                    'createdAtOn',
                ].forEach((str) => {
                     this.pickers.push(flatpickr(this.$refs[str]));
                });
            },
            updateFromLocalStorage() {
                for (let filter in this.showRange) {
                    let val = localStorage[`boxes/showRange/${filter}`];
                    if (val !== undefined) {
                        this.showRange[filter] = !!parseInt(val);
                    }
                }
            },
            updateLocalStorage() {
                for (let filter in this.showRange) {
                    localStorage[`boxes/showRange/${filter}`] = this.showRange[filter] ? 1 : 0;
                }
            },
        },
        mounted() {
            this.initDatePicker();
            this.updateFromLocalStorage();
            for (let key in this.showRange) {
                this.$watch(`showRange.${key}`, function(val) {
                    // clear hidden filters, copy val from<->on
                    if (val) {
                        this.updateFilterProp({ name: `date#${key}#from`, value: this.filter[`date#${key}#on`] });
                        this.updateFilterProp({ name: `date#${key}#on`, value: '' });
                    } else {
                        this.updateFilterProp({ name: `date#${key}#on`, value: this.filter[`date#${key}#from`] });
                        this.updateFilterProp({ name: `date#${key}#from`, value: '' });
                        this.updateFilterProp({ name: `date#${key}#to`, value: '' });
                    }
                    this.updateLocalStorage();
                });
            }
        },
        beforeDestroy() {
            this.pickers.forEach(p => p.destroy());
        }
    };
</script>
<style lang="scss" scoped>
    @import '~flatpickr/dist/flatpickr.min.css';
    @import '~flatpickr/dist/themes/light.css';

    #expanded-filter {
        width: 450px;
        max-width: 100%;
        padding: 0.5em;
    }
    .section {
        &:not(:first-child) {
            margin-top: 0.75em;
        }
    }

    .clear {
        @extend a;
        margin-left: 0.35em;
    }

    .split {
        display: flex;

        > * {
            flex: 1;

            &:not(:first-child) {
                margin-left: 0.5em;
            }
        }
    }

    .date-group {
        display: flex;
        align-items: center;

        input {
            width: 125px;
        }

        .toggle-button-group {
            flex-shrink: 0;
        }

        .dates {
            display: flex;
            align-items: center;

            > * {
                margin-left: 0.5em;
            }

            .range-and {
                text-align: center;
            }
        }
    }
</style>